/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import ContextConstructor from "../../components/Context/Context";
import MGChipSingleSelect from "../../components/MGChipSingleSelect/MGChipSingleSelect";
import DocumentItem from "./DocumentItem"
import { downloadPdf } from "./downloadPdf";

/* MODULE IMPORTS */
import React, { Component } from "react";
import { ArrowLeft } from "lucide-react";

/* CSS IMPORT */
import "./Correio.css";
import "../../components/Loading/loading.css";
import "../Beneficios/Pagination.css";
import "../../components/ErrorPage/ErrorPage.css";
import sendLogError from "../../sendLogError";

import loadingImg from "../../images/loading.svg";
import { handleChannelBack } from "../../utils/handleChannelBack";

var reactPlugin = new ReactPlugin();

class Correio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingDocument: false,
      mailList: [],
      Sort: "1"
    };
  }

  async componentDidMount() {

    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populateData();
    }
  }

  errorLoading() {
    return (
      <div>
        <ErrorPage />
      </div>
    );
  }

  setSort(value) {
    this.setState({
      Sort: value,
    });
  }

  handleDocumentClick(doc) {
    const id = doc.documentCode;
    const documentClass = doc.documentClass;
    const documentDate = doc.date;
    const documentName = doc.title +".pdf";

    this.getMailContent(documentDate, id, documentClass, documentName);

    if (doc.isRead !== true) {
      this.markDocumentAsRead(doc, this.state);
    }

  };

  renderMailListTable(mailList) {
    return (
      <div className="doc-cards-container">
        {mailList.map((doc) => (
          <DocumentItem
            key={doc.documentCode}
            document={doc}
            onSelect={(doc) => this.handleDocumentClick(doc)}
          />
        ))}
      </div>
    );
  }

  updateTableReadState(rowInfo, state) {

    const list = state.mailList.map((item)=>(
      item.documentCode === rowInfo.documentCode 
      ? { ...item,isRead:true}
      : item
    ))

    this.setState({
      mailList: list,
      loading: false,
    });
  }

  renderListagemCorreio(mailList) {
    var loading = this.state.loadingDocument ? (
      <div className="document-page-document-loading">
        <div className="loading loading-document">
          <img src={loadingImg}></img>
        </div>
      </div>
    ) : (
      <div></div>
    );

    const list = this.sortByDate(mailList)

    return (
      <main className="main-mail">
        <div className="title-bar title-bar-mail">
          <div className="mail-header">
            <div className="title">
              <ArrowLeft
                className="profile-title-back"
                onClick={() => {
                  this.handleBack();
                }}
              />
              Correio Digital

            </div>
            <div className="mail-sort">
              <MGChipSingleSelect label={"Mais recentes"} isSelected={this.state.Sort === "1"} onClick={() => { this.setSort("1") }} />
              <MGChipSingleSelect label={"Mais antigos"} isSelected={this.state.Sort === "2"} onClick={() => { this.setSort("2") }} />
            </div>
          </div>
        </div>
        <div className="mail-list-wrapper" style={{ position: "relative" }}>
          <div className="mail-list">{this.renderMailListTable(list)}</div>
          {loading}
        </div>
      </main>
    );
  }

  handleBack = () => {
    handleChannelBack({
      isMobileAuth: this.context.isMobileAuth,
      onWebBack: () => this.props.history.goBack(),
    });
  };

  renderListagemCorreioVazia() {
    return (
      <main className="main-mail">
        <div className="title-bar title-bar-mail">
          <div className="title">
            <ArrowLeft
              className="profile-title-back"
              onClick={() => {
                this.handleBack();
              }}
            />
            Correio Digital</div>
        </div>
        <div className="notifications-empty">
          <svg
            className="notifications-empty__icon"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M17 8H29"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <path
              d="M17 18H29"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <path
              d="M17 28H29"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <rect
              x="3.5"
              y="4"
              width="5"
              height="5"
              rx="1"
              stroke="currentColor"
              strokeWidth="2.5"
            />
            <rect
              x="3.5"
              y="14"
              width="5"
              height="5"
              rx="1"
              stroke="currentColor"
              strokeWidth="2.5"
            />
            <rect
              x="3.5"
              y="24"
              width="5"
              height="5"
              rx="1"
              stroke="currentColor"
              strokeWidth="2.5"
            />
            <circle
              cx="26"
              cy="9"
              r="5"
              fill="white"
              stroke="currentColor"
              strokeWidth="2.5"
            />
            <path
              d="M30 13L33 16"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
          Não tem correio digital
        </div>
      </main>
    );
  }

  sortByDate(items) {
    return [...items].sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();

      return this.state.Sort === "2"
        ? dateA - dateB
        : dateB - dateA;
    });
  }

  render() {
    let contents = "";

    if (this.state.loading) {
      contents = (
        <div className="main-page-loading">
          <div className="loading">
            <img src={loadingImg}></img>
          </div>
        </div>
      );
    } else if (this.state.error) {
      contents = this.errorLoading();
    } else if (this.state.mailList.length) {
      contents = this.renderListagemCorreio(this.state.mailList);
    } else {
      contents = this.renderListagemCorreioVazia();
    }

    return <div>{contents}</div>;
  }

  async populateData() {
    try {
      const { idToken, selectedUserID } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch(
        `/Document/GetDocument?ClientId=${selectedUserID}`,
        { headers }
      );

      if (response.status === 404) {
        console.log("No content!");

        this.setState({
          loading: false,
          error: false,
        });

        sendLogError("No content!", "populateData");
        return;
      }

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      this.setState({
        mailList: Array.isArray(data) ? data : [],
        error: false,
        loading: false,
      });

    } catch (error) {
      console.error("Error fetching documents:", error);

      this.setState({
        error: true,
        loading: false
      });

      sendLogError(error.message, "populateData");
    }
  }

  async markDocumentAsRead(rowInfo, state) {
    try {
      const { idToken } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      };
      const response = await fetch("/Document/MarkDocumentAsRead", {
        method: "POST",
        headers,
        body: JSON.stringify({
          DocumentId: String(rowInfo.documentCode),
          Client_id: String(rowInfo.client_id),
          Associate_number: String(rowInfo.associate_number),
          Associate_control_digit: String(rowInfo.associate_control_digit),
        }),
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (data === true) {
        this.updateTableReadState(rowInfo, state);
      } else {
        console.warn("Unexpected response marking document as read:", data);
      }

    } catch (error) {
      console.error("Error marking document as read:", error);

      sendLogError(error.message, "markDocumentAsRead");
    }
  }

  async getMailContent(documentDate, id, documentClass, documentName) {
    try {
      this.setState({ loadingDocument: true });

      const requestUrl = `/Document/GetDocumentContent?documentDate=${encodeURIComponent(
        documentDate
      )}&id=${encodeURIComponent(id)}&documentClass=${encodeURIComponent(documentClass)}`;

      const headers = {
        Authorization: `Bearer ${this.context.idToken}`,
      };

      const response = await fetch(requestUrl, { headers });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const responseJson = await response.json();
      const base64 = responseJson?.value;

      if (!base64) {
        throw new Error("Documento vazio");
      }
      downloadPdf(base64,documentName);

    } catch (error) {
      console.error("Error fetching mail content:", error);

      sendLogError(error.message, "getMailContent");
    } finally {
      this.setState({ loadingDocument: false });
    }
  }
}

Correio.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Correio);
